<script lang="ts">
	import { fly } from 'svelte/transition'
	import { ui } from '#library/stores.ts'

	let { items = [] } = $props()
	let scrollY = $state(0)
	let innerHeight = $state(0)

	const show = $derived.by(() => {
		const { offsetTop, offsetHeight } = $ui.main || { offsetTop: 0, offsetHeight: 0 }
		return scrollY > offsetTop && scrollY < offsetTop + offsetHeight - innerHeight
	})

	// TODO: add scroll sync so anchors are in view when scrolling
</script>

<svelte:window bind:innerHeight bind:scrollY />

{#if show && items.length}
	<div class="subnav contain" transition:fly={{ y: 100 }}>
		{#each items as { id, name }, i (i)}
			<a href="#{id}" class="link">{name}</a>
		{/each}
		<a href="#top" class="link">
			Top <svg class="svg"><use xlink:href="/images/vector.svg#arrow-up"></use></svg>
		</a>
	</div>
{/if}

<style lang="css">
	.subnav {
		align-items: center;
		background-color: var(--c-white);
		border-radius: var(--r-o);
		border: 1px solid var(--c-gimson);
		box-shadow: 0 10px 40px hsl(0 0% 0% / 0.15);
		display: inline-flex;
		gap: 1.5rem;
		height: 2.75rem;
		inset: auto auto 1rem 50%;
		overflow-x: auto;
		padding: 0.5rem 2rem;
		position: fixed;
		scrollbar-width: none;
		transform: translateX(-50%);
		z-index: 2;

		@media (--from-mobile) {
			height: 3.5rem;
			inset: auto auto 3rem 50%;
			justify-content: center;
			width: max-content;
		}

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.link {
		align-items: center;
		color: var(--c-charcoal);
		display: flex;
		flex: 0 0 auto;
		font: 500 var(--f-signpost);
		gap: 0.5rem;
		letter-spacing: var(--ls-signpost);
		padding-inline: 1rem;
		text-transform: uppercase;
		transition: color 0.2s ease;
		white-space: nowrap;

		&:hover,
		&:target {
			color: var(--c-rose);
		}
	}

	.svg {
		size: 1.125rem;
	}
</style>
